import { Box, Divider, Grid, InputAdornment, Typography, useTheme } from "@mui/material"
import SearchTextField from "components/StyledComponents/SearchTextField"
// import CategoryCard from "pages/private/learning_development/QuestionBank/components/CategoryCard"
import React, { Fragment, useEffect, useState } from "react"
import { Col } from "react-bootstrap"
import CreateIcon from "@mui/icons-material/Create"
import DeleteIcon from "@mui/icons-material/Delete"
import SearchIcon from "@mui/icons-material/Search"
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked"
import CheckCircleIcon from "@mui/icons-material/CheckCircle"
import AppSelect from "components/StyledComponents/AppSelect"
import styles from "../../../PendingQuestionTable.module.scss"
import ImageDisplay from "components/ImageDisplayer"
import DeleteConfirmationDialog from "components/DeleteConfirmationDialog"
import AppPagination from "components/StyledComponents/AppPagination"
import AppButton from "components/StyledComponents/AppButton"
import Questions from "./Questions"
import EditQuestion from "./EditQuestion"
import Card from "components/Card/Card"
import {
  addToWeeklyQuestionBankAction,
  bulkDeleteQuestionsAction,
  deleteWeeklyQuestionFromBankAction,
  editChallengeQuestionAction,
  getCommentsAction
} from "redux/marketing/actions"
import { useDispatch, useSelector } from "react-redux"
import { useHistory } from "react-router-dom"
import { marketingActions } from "redux/marketing/slice/user"
import { ReactComponent as CommentIcon } from "assets/icons/commentIcon.svg"

const btnText = {
  questionBank: "Add To Question Bank",
  triviaText: "Add to Challenge"
}

const style = {
  card: {
    padding: "24px 0"
  },
  box: {
    padding: "0px 24px",
    background: "none"
  },
  divider: {
    background: "#7f7f7f",
    height: "2px",
    opacity: 0.12
  },
  btnQuestion: {
    paddingLeft: "47px",
    paddingRight: "47px"
  },
  checkBoxPosition: {
    cursor: "pointer",
    marginLeft: 10,
    marginRight: 14
  }
}

const QuestionsList = ({
  questions,
  isEditable = false,
  showImage = true,
  showPagination = true,
  // questionCategoryCount,
  // categoryCount,
  searchValue,
  setSearchValue,
  questionFilter,
  filterOptions,
  filterQuestion,
  setFilterQuestion,
  setCurrentPage,
  allQuestions,
  currentPage = 1,
  itemsPerPage = 12,
  isDelete,
  showRank = false,
  RankOpt,
  isWeeklyChallenge = false,
  pages = 0,
  handleAddToChallenge,
  platform,
  isGenerateQuestion = false,
  isBulkDeletePopupOpen,
  setIsBulkDeletePopupOpen,
  onSelectionChange,
  activeTab
}) => {
  const theme = useTheme()
  const history = useHistory()
  const dispatch = useDispatch()
  const [selectAll, setSelectAll] = useState(false)
  const [openEditDialog, setOpenEditDialog] = useState(false)
  const [editData, setEditData] = useState()
  const [selectedQuestionsObjects, setSelectedQuestionsObjects] = useState([])
  const [selectedQuestions, setSelectedQuestions] = useState([])
  const [execeptQuestions, setExceptQuestions] = useState([])
  const [isDeletePopupOpen, setIsDeletePopupOpen] = useState(false)
  const [deleteQuestion, setDeleteQuestion] = useState("")
  const { isLoading } = useSelector((state) => state?.app)

  const handleEditDialogOpen = (question) => {
    dispatch(marketingActions.setTastingNotesImages([]))
    setEditData(question)
    dispatch(getCommentsAction({ id: question?.id }))
    setOpenEditDialog(true)
  }

  const handleOpenDelete = (question) => {
    setIsDeletePopupOpen(true)
    setDeleteQuestion(question)
  }

  const handleCloseDelete = () => {
    setIsDeletePopupOpen(false)
  }
  const handleEditDialogClose = () => {
    setOpenEditDialog(false)
  }

  const handleDeleteQuestion = () => {
    setCurrentPage(1)
    dispatch(deleteWeeklyQuestionFromBankAction({ questionId: deleteQuestion?.id }))
  }

  const deleteAllQuestion = () => {
    const payload = {
      question_ids: selectedQuestions
    }
    setCurrentPage(1)
    dispatch(
      bulkDeleteQuestionsAction({
        payload,
        onClose: () => setIsBulkDeletePopupOpen(false)
      })
    )
  }

  const handleRank = (data, newRank) => {
    let payload = {
      rank: newRank
    }

    dispatch(
      editChallengeQuestionAction({
        questionId: data.id,
        questionData: payload,
        question_used: filterQuestion,
        platform,
        isRankUpdate: true,
        weeklyChallenge: false,
        onClose: () => {}
      })
    )
  }

  const checkSelected = (ID) => {
    if (selectAll && execeptQuestions?.length === 0) {
      return true
    }
    if (selectAll && execeptQuestions?.length > 0) {
      let exceptIems = execeptQuestions.filter((data) => data === ID)
      if (exceptIems?.length > 0) {
        return false
      } else {
        return true
      }
    } else {
      let isItemSelected = selectedQuestions.filter((item) => item === ID)
      if (isItemSelected?.length > 0) {
        return true
      } else {
        return false
      }
    }
  }

  const handleQuestionSelect = () => {
    if (selectAll && execeptQuestions?.length > 0) {
      setExceptQuestions([])
      const uniqueQuestions = questions?.filter(
        (question) => !selectedQuestionsObjects?.some((selected) => selected?.id === question?.id)
      )
      setSelectedQuestionsObjects(uniqueQuestions)
      return
    } else {
      setSelectedQuestionsObjects(allQuestions)
    }
    setSelectedQuestions([])
    setExceptQuestions([])
    setSelectAll((prevSelectAll) => !prevSelectAll)
  }

  const handleSelectQuestion = (ID, question) => {
    if (selectAll) {
      const isExceptQuestionsAvailable = execeptQuestions?.filter((item) => item === ID)
      if (isExceptQuestionsAvailable?.length > 0) {
        const updatedExceptQuestionList = execeptQuestions?.filter((item) => item !== ID)
        setExceptQuestions(updatedExceptQuestionList)
        selectedQuestionsObjects?.length > 0
          ? setSelectedQuestionsObjects([...selectedQuestionsObjects, question])
          : setSelectedQuestionsObjects([question])
      } else {
        setExceptQuestions([...execeptQuestions, ID])
        setSelectedQuestionsObjects(selectedQuestionsObjects?.filter((item) => item?.id !== ID))
      }
    } else {
      //check that question is already selected or not
      const isAvailable = selectedQuestions.filter((item) => item === ID)
      //if item is already selected remove that item from list
      if (isAvailable?.length > 0) {
        const updatedList = selectedQuestions.filter((item) => item !== ID)
        setSelectedQuestions(updatedList)
        setSelectedQuestionsObjects(selectedQuestionsObjects?.filter((item) => item?.id !== ID))
      } else {
        //add new item in list
        setSelectedQuestions([...selectedQuestions, ID])
        if (selectedQuestionsObjects.length === allQuestions?.length) {
          setSelectedQuestionsObjects(selectedQuestionsObjects?.filter((item) => item?.id !== ID))
        } else {
          selectedQuestionsObjects?.length > 0
            ? setSelectedQuestionsObjects([...selectedQuestionsObjects, question])
            : setSelectedQuestionsObjects([question])
        }
      }
    }
  }

  const handleAddQuestionsToChallenge = () => {
    const payload = {
      is_all_selected: selectAll,
      question_ids: selectedQuestions,
      excepted_ids: execeptQuestions
    }
    handleAddToChallenge(payload)
  }

  const handleAddToBank = () => {
    const questionIds = questions?.map((question) => question.id)
    const payload = {
      is_all_selected: selectAll,
      question_ids: selectedQuestions,
      excepted_ids: execeptQuestions,
      ...(selectAll ? { all_question_ids: questionIds } : null)
    }

    dispatch(
      addToWeeklyQuestionBankAction({
        payload,
        handleRoute: () => history.push("/learning_development/dashboard/weekly-question-bank")
      })
    )
  }

  const checkButtonDisable = () => {
    if (selectAll || selectedQuestions?.length > 0 || execeptQuestions?.length > 0) {
      return true
    } else {
      return false
    }
  }

  const handleSearchField = (e) => {
    setSearchValue(e.target.value)
  }

  const handleFilter = (event) => {
    setFilterQuestion(event.target.value)
    setCurrentPage(1)
  }

  const renderFilterSection = () => (
    <Grid container justifyContent="flex-end" spacing={1}>
      {questionFilter && (
        <Grid item xs={4}>
          <AppSelect menuItems={filterOptions} value={filterQuestion} onChange={handleFilter} />
        </Grid>
      )}
      {questions?.length > 0 && (
        <Grid item xs={2.5} xl={2} display="flex" justifyContent="flex-end" alignItems="center">
          <Typography>
            Select All
            {selectAll && execeptQuestions?.length === 0 ? (
              <CheckCircleIcon
                htmlColor={theme.palette.secondary.main}
                onClick={handleQuestionSelect}
                style={style.checkBoxPosition}
              />
            ) : (
              <RadioButtonUncheckedIcon
                style={style.checkBoxPosition}
                onClick={handleQuestionSelect}
              />
            )}
          </Typography>
        </Grid>
      )}
    </Grid>
  )

  const renderSearchSection = () => (
    <>
      <Grid container item xs={12} justifyContent="flex-end">
        {!isGenerateQuestion && (
          <Grid item xs={4}>
            <SearchTextField
              id="search"
              name="search"
              value={searchValue}
              onChange={handleSearchField}
              fullWidth
              type="search"
              placeholder="Search"
              InputProps={{
                disableUnderline: true,
                endAdornment: (
                  <InputAdornment
                    position="end"
                    sx={{
                      backgroundColor: theme.palette.background.secondary
                    }}>
                    <SearchIcon htmlColor="#C4C4C4" />
                  </InputAdornment>
                )
              }}
              style={{
                border: "1px solid #C4C4C4",
                backgroundColor: theme.palette.background.secondary,
                borderRadius: 6
              }}
            />
          </Grid>
        )}

        <Grid container item xs={8} justifyContent="flex-end">
          {renderFilterSection()}
        </Grid>
      </Grid>
    </>
  )

  useEffect(() => {
    if (onSelectionChange) onSelectionChange(selectedQuestions)
  }, [selectedQuestions, onSelectionChange])

  return (
    <>
      {openEditDialog ? (
        <EditQuestion
          onClose={handleEditDialogClose}
          data={editData}
          currentPage={currentPage}
          filterQuestion={filterQuestion}
          platform={platform}
          showRank={showRank}
          RankOpt={RankOpt}
          activeTab={activeTab}
        />
      ) : null}
      <DeleteConfirmationDialog
        open={isDeletePopupOpen}
        onClose={() => handleCloseDelete()}
        onDelete={() => handleDeleteQuestion()}
        description="Are you sure you want to delete this question?"
      />
      <DeleteConfirmationDialog
        open={isBulkDeletePopupOpen}
        onClose={() => setIsBulkDeletePopupOpen(false)}
        onDelete={deleteAllQuestion}
        description={`Are you sure to delete ${
          selectedQuestions?.length > 1 ? `all` : ""
        } the Selected ${selectedQuestions?.length > 1 ? `questions` : `question`} ?`}
      />
      {/* TO DO */}
      {/* {categoryCount && (
        <Row>
          <Col lg="12">
            <Box className="d-flex w-100 flex-wrap">
              {questionCategoryCount?.map((option, index) => (
                <CategoryCard
                  key={index}
                  title={option?.title}
                  category={option?.category}
                  count={option?.count}
                />
              ))}
            </Box>
          </Col>
        </Row>
      )} */}

      <Grid container minWidth={520} xs={12} mt={2} justifyContent="flex-end">
        {renderSearchSection()}
      </Grid>

      <Card sx={style.card}>
        {questions?.length > 0 ? (
          questions?.map((question, index) => (
            <Fragment key={question?.id}>
              <Box
                key={question?.id}
                className={`${styles.questionCtr} ${
                  question?.is_used_in_weekly_challenge ? styles.question_added : ""
                }`}
                sx={style.box}>
                <Grid container>
                  <Grid item xs={10}>
                    <div className="d-flex">
                      <div
                        className={styles.countBorder}
                        style={{
                          borderColor: "#FFFFFF",
                          marginTop: 25,
                          marginRight: 10
                        }}>
                        {currentPage * itemsPerPage - (itemsPerPage - 1) + index}
                      </div>
                      {showImage ? (
                        <div className="d-flex ml-2">
                          <div
                            className="me-3 mt-3 p-2 d-flex justify-content-center"
                            style={{ width: "180px", height: "180px" }}>
                            <ImageDisplay data={question.image} keyProp={"image"} />
                          </div>
                        </div>
                      ) : (
                        <div style={{ marginLeft: 20 }}></div>
                      )}
                      <Questions question={question} status={question?.status} index={index} />
                    </div>
                  </Grid>
                  <Grid
                    item
                    xs={2}
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "space-between"
                    }}>
                    <div>
                      <Grid container justifyContent="flex-end">
                        <div style={{ marginTop: 20 }}>
                          <Grid container alignItems="center" spacing={1}>
                            {question?.comment_count > 0 && (
                              <Grid item className="d-flex mt-1 me-1">
                                <CommentIcon className="me-1" style={{ height: 24, width: 24 }} />
                                <Typography variant="caption1" color={theme.palette.white.main}>
                                  {question?.comment_count}
                                </Typography>
                              </Grid>
                            )}
                            <Grid item>
                              {isEditable && (
                                <>
                                  {isEditable && (
                                    <CreateIcon
                                      sx={(theme) => ({
                                        color: theme.palette.white.main,
                                        cursor: "pointer"
                                      })}
                                      className="me-2"
                                      onClick={() => handleEditDialogOpen(question)}
                                    />
                                  )}
                                </>
                              )}
                            </Grid>
                            {isDelete ? (
                              <Grid item>
                                <DeleteIcon
                                  sx={{ cursor: "pointer" }}
                                  onClick={() => handleOpenDelete(question)}
                                />
                              </Grid>
                            ) : null}
                            <Grid item>
                              {checkSelected(question?.id) ||
                              question?.is_used_in_weekly_challenge ? (
                                <CheckCircleIcon
                                  htmlColor={theme.palette.secondary.main}
                                  onClick={() =>
                                    !question?.is_used_in_weekly_challenge &&
                                    handleSelectQuestion(question?.id, question)
                                  }
                                  style={{ cursor: "pointer" }}
                                />
                              ) : (
                                <RadioButtonUncheckedIcon
                                  style={{ cursor: "pointer" }}
                                  onClick={() => handleSelectQuestion(question?.id, question)}
                                />
                              )}
                            </Grid>
                          </Grid>
                        </div>
                      </Grid>
                      <Grid item mt={2} display="flex" justifyContent="flex-end" gap={2}>
                        {question?.is_added_manually ? (
                          <Typography className={styles.inUse} variant="body2Regular">
                            Manual
                          </Typography>
                        ) : null}
                        {question?.is_used_in_weekly_challenge ? (
                          <Typography className={styles.inUse} variant="body2Regular">
                            In Use
                          </Typography>
                        ) : null}
                      </Grid>
                    </div>
                    {showRank && (
                      <Grid item my={2}>
                        <Grid container justifyContent="flex-end" alignContent="center">
                          <Grid item mr={1}>
                            <Typography variant="tag1">Rank: </Typography>
                          </Grid>
                          {RankOpt?.map((rank, index) => (
                            <Grid
                              item
                              key={index}
                              className={
                                question?.rank !== rank ? styles.rank : styles.rank_selected
                              }
                              style={{
                                marginRight: index !== RankOpt.length - 1 ? "12px" : "0px"
                              }}
                              onClick={() => handleRank(question, rank)}>
                              {rank}
                            </Grid>
                          ))}
                        </Grid>
                      </Grid>
                    )}
                  </Grid>
                </Grid>
              </Box>
              {questions?.length - 1 > index && <Divider sx={style.divider} />}
            </Fragment>
          ))
        ) : (
          <Typography variant="h2" className="d-flex justify-content-center">
            {isLoading ? "Please wait, we are fetching the questions..." : "No Questions Found"}
          </Typography>
        )}
        {showPagination && pages > 0 && (
          <AppPagination
            onPageChange={setCurrentPage}
            totalPages={pages}
            currentPage={currentPage}
          />
        )}
      </Card>
      {questions?.length > 0 && (
        <>
          <Col
            lg="12"
            className={
              isWeeklyChallenge ? "d-flex justify-content-between" : "d-flex justify-content-end"
            }>
            <AppButton
              styles={
                isWeeklyChallenge
                  ? { paddingLeft: 47, paddingRight: 47 }
                  : { paddingLeft: 13, paddingRight: 13 }
              }
              disabled={checkButtonDisable() ? false : true}
              onClick={isWeeklyChallenge ? handleAddQuestionsToChallenge : handleAddToBank}>
              {isWeeklyChallenge ? btnText.triviaText : btnText.questionBank}
            </AppButton>
          </Col>
        </>
      )}
    </>
  )
}

export default QuestionsList
